import _ from 'lodash';

export function getTruncatedString(string, maxLength) {
  if (string.length - 3 <= maxLength) {
    return string;
  } else {
    return string.slice(0, maxLength) + '...';
  }
}

export function generateRandomColor() {
  return (
    '#' +
    Math.floor((Math.random() * Math.pow(2, 32)) ^ 0xffffff)
      .toString(16)
      .substr(-6)
  );
}

export function quantile(arr: number[], q) {
  const sorted = _.sortBy(arr, el => el);
  const pos = (sorted.length - 1) * q;
  const base = Math.floor(pos);
  const rest = pos - base;
  if (sorted[base + 1] !== undefined) {
    return sorted[base] + rest * (sorted[base + 1] - sorted[base]);
  } else {
    return sorted[base];
  }
}

export function euclideanDistance(element1, element2) {
  return Math.sqrt(
    Math.pow(element1.get('x') - element2.get('x'), 2) +
      Math.pow(element1.get('y') - element2.get('y'), 2),
  );
}

//https://jsfiddle.net/tovic/b83HH/
const colorLuminance = (hex, lum) => {
  // Validate hex string
  hex = String(hex).replace(/[^0-9a-f]/gi, '');
  if (hex.length < 6) {
    hex = hex.replace(/(.)/g, '$1$1');
  }
  lum = lum || 0;
  // Convert to decimal and change luminosity
  let rgb = '#',
    c;
  for (let i = 0; i < 3; ++i) {
    c = parseInt(hex.substr(i * 2, 2), 16);
    c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
    rgb += ('00' + c).substr(c.length);
  }
  return rgb;
};
//https://coolors.co/292f36-63d2ff-7dc855-fa824c-aa3e98-ffa3af-9ceaef-747572-ffc857-7a82ab
const DEFAULT_COLORS = [
  '292f36',
  '63d2ff',
  '7dc855',
  'fa824c',
  'aa3e98',
  'ffa3af',
  '9ceaef',
  '747572',
  'ffc857',
  '7a82ab',
].map(val => '#' + val);

export function ordinalColorScale(n = 100) {
  const colors = DEFAULT_COLORS.map(color => color);

  for (let i = 0; i < n - DEFAULT_COLORS.length; i++) {
    colors.push(generateRandomColor());
  }

  return function (index) {
    return colorLuminance(colors[index], -0.2);
  };
}

export function median(array) {
  array = array.sort();
  if (array.length % 2 === 0) {
    // array with even number elements
    return (array[array.length / 2] + array[array.length / 2 - 1]) / 2;
  } else {
    return array[(array.length - 1) / 2]; // array with odd number elements
  }
}
